// The /max entry ships the full validation patterns; the default (min)
// metadata only checks lengths and accepts BR numbers without area code.
import { isValidPhoneNumber } from 'libphonenumber-js/max'
import { z } from 'zod'

import { AccountType } from '@/api/v1/administration/account/account.enums'

export const accountProfileSchema = z.object({
  type: z.nativeEnum(AccountType, {
    message: 'validation.type.required',
  }),
  accountName: z
    .string()
    .min(2, 'validation.accountName.min')
    .max(200, 'validation.accountName.max'),
  countryCode: z.string().min(1, 'validation.country.required'),
  phone: z
    .string()
    .min(1, 'validation.phone.required')
    .refine((value) => isValidPhoneNumber(value), 'validation.phone.invalid'),
})

export type AccountProfileData = z.infer<typeof accountProfileSchema>
